<template>
  <div class="flex border rounded-lg shadow-lg p-4 bg-white" @click="toggleBackground" :class="{ active: isActive }">
    <div class="flex flex-col justify-center w-2/3 min-h-[80px]">
      <div class="text-lg font-semibold">{{ title }}</div>
      <div class="text-gray-600">{{ description }}</div>
    </div>
    <div class="flex items-center justify-center w-1/3">
       <slot name="icon"> <!-- 使用插槽 -->
        <el-icon><CirclePlus /></el-icon> <!-- 默认图标 -->
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isActive: false, // 激活状态
    };
  },
  methods: {
    toggleBackground() {
      this.isActive = !this.isActive; // 切换激活状态
    },
  },
};
</script>

<style scoped>
.active {
  background-color: #f0f8ff; /* 激活时的背景颜色 */
}
.flex:hover {
  background-color: #e9e5e2; /* 点击时的背景颜色 */
}

.flex {
  transition: background-color 0.3s; /* 平滑过渡效果 */
}

</style>
